import { useNavigate } from "react-router";

/**
 * Custom hook that provides a function to replace a segment of the current route with a new ID.
 *
 * @returns An object containing the `replaceId` function.
 *
 * @example
 * const { replaceId } = useReplaceRouteId();
 * replaceId('user', 123); // Replaces the segment 'user' with the ID 123 in the current route.
 *
 * @function
 * @name useReplaceRouteId
 *
 * @function
 * @name replaceId
 * @param {string} segment - The segment of the route to be replaced.
 * @param {number | string} replacementId - The new ID to replace the segment with.
 */
export function useReplaceRouteId() {
  const navigate = useNavigate();

  const replaceId = (segment: string, replacementId: number | string) => {
    let currentPath = window.location.pathname;

    if (window.location.search) {
      currentPath += window.location.search;
    }
    const regex = new RegExp(`/${segment}/[^/?]+`);
    const newPath = currentPath.replace(regex, `/${segment}/${replacementId}`);
    navigate(newPath);
  };

  return { replaceId };
}
